import { render, staticRenderFns } from "./meineEinstellungen.vue?vue&type=template&id=e1960224&"
import script from "./meineEinstellungen.vue?vue&type=script&lang=js&"
export * from "./meineEinstellungen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports